
const tibiotMoudle={
  namespaced: true,
  state:{
    searchIccid:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default tibiotMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/tibiot.js